module.exports = __webpack_public_path__ + "static/media/5.1e43d52d.jpg";